import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from './services/customer.service';
import { PaymentPlanDefaults } from '../payment-hub/model/payment-plan';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

    @ViewChild('content') content: any;

  selectedCustomers = 'Select customer...';
  paymentHubData: any;
  payLoadData: any;
  data: any;

  constructor(private modalService: NgbModal, private customerService: CustomerService, private router: Router) {
    this.paymentHubData = undefined;
    this.payLoadData = undefined;
    this.data = undefined;
  }

  ngOnInit(): void {
      localStorage.clear();
      const q = this.router.parseUrl(this.router.url);
      if ('q' in q.queryParams && q.queryParams.q) {
          console.log(q.queryParams.q);
          this.loadPayLoadData(q.queryParams.q);
      }
  }

  onSubmit(payhubdata: any) {
    this.data = payhubdata;
    if (this.data.customers.length > 1) {
        this.modalService.open(this.content);
    } else {
        this.loadPaymentHub(this.data);
    }
  }

  onselectedCustomer(payhubdata: any, selectedCustomer: any) {
    payhubdata.customers = payhubdata.customers.filter(customer => customer === selectedCustomer);
    this.loadPaymentHub(payhubdata);
    this.modalService.dismissAll();
  }

    loadPayLoadData(transactionId: any) {
        this.customerService.getPayloadData(transactionId).subscribe(res => {
            if (res.status != 200) {
                console.log(res);
                alert(res.body);
                return;
            }
            const bodyData = res.body;
            this.onSubmit(bodyData);
            localStorage.setItem(PaymentPlanDefaults.CONSTANT_USERNAME, bodyData.userName);
            localStorage.setItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID, transactionId);
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    loadPaymentHub(payhubdata: any) {
        this.payLoadData = payhubdata;
        const payload = payhubdata;
        payload.customers.map(function (customers) {
            customers.accounts.map(function (accounts) {
                accounts.invoices.map(function (invoices) {
                    invoices.invoiceDate = invoices.invoiceDate.year + '-' + (invoices.invoiceDate.month < 10 ? '0' : '') + invoices.invoiceDate.month + '-' + (invoices.invoiceDate.day < 10 ? '0' : '') + invoices.invoiceDate.day;
                    invoices.dueDate = invoices.dueDate.year + '-' + (invoices.dueDate.month < 10 ? '0' : '') + invoices.dueDate.month + '-' + (invoices.dueDate.day < 10 ? '0' : '') + invoices.dueDate.day;
                });
            });
        });
        this.payLoadData = payload;
        this.paymentHubData = payhubdata;
    }
}
